import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}><path d="M21.728 23.36l-5.632-5.632-5.664 5.632a1.152 1.152 0 01-1.598-1.634l-.002.002 5.664-5.664-5.664-5.632a1.152 1.152 0 011.603-1.598l-.004-.003 5.664 5.632 5.632-5.632a1.152 1.152 0 011.598 1.603l.003-.004-5.6 5.664 5.632 5.632a1.154 1.154 0 01-1.632 1.632z" /></svg>;